import DateHelper from './DateHelper';
import Helper from './Helper';
export {
    BatchAssessment,
    QualityDeviation
};

class QualityDeviation {
  constructor(data) {
    this.parameter = data.parameter;
    this.actual = data.actual;
    this.target = data.target;
    this.deviationValue = data.deviationValue;
    this.severity = data.severity;
    this.impact = data.impact;
    this.unit = data.unit;
    this.description = data.description ?? null;
  }
}

class BatchAssessment {
  constructor(data) {
    this.batchId = data.batchId;
    this.grade = data.grade;
    this.explanation = data.explanation;
    this.deviations = data.deviations.map(d => new QualityDeviation(d));
    this.assessmentDate = new Date(data.assessmentDate);
    this.trustScore = data.trustScore;
    this.totalWeight = data.totalWeight;
  }

  getQualityDeviationsBySeverity(severity) {
    return this.deviations.filter(d => d.severity === severity);
  }

  isPassing(threshold = 5.5) {
    return this.grade !== undefined && this.grade >= threshold;
  }
}